import { set } from "@/utils/vuex";

export default {
  resetState(state) {
    if (state) {
      Object.assign(state, state.getDefaultState());
    }
  },
  setFiles: set("files"),
  setLoading: set("loading"),
  setItemLoading: set("itemLoading"),
  setFile: set("file"),
  setFileItems: set("fileItems"),
  setFileItem: set("fileItem"),
  setUtilityFileId: set("utility_file_id"),
};
